export default () => {
  return {
    composites: [],
    consumers: [],
    dags: [],
    dataProducts: [],
    datasets: [],
    dispatches: [],
    orgs: [],
    pipelines: [],
    suppliers: [],
  };
};
